<div class="d-flex justify-content-center align-items-center gap-2 content-waiting-time">
  <div class="rounded-circle circle-waiting-time" [class]="getWaitingTimeClass()"></div>
  <div class="rounded-circle circle-waiting-time" [class]="getWaitingTimeClass()"></div>
</div>
